import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, SplitButton } from '@progress/kendo-react-buttons';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { KBApi } from '../../../../../../redux/api/KBApi';
import * as svg from '@progress/kendo-svg-icons';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { AssetApi } from '../../../../../../redux/api/AssetApi';
import { useCurrentUserContext } from '../../../../../../context/UserContext';

const AssetButton: React.FC<ITicketProps> = (ticket) => {
    const navigate = useNavigate();
    const { profile: userProfile } = useCurrentUserContext();
    const [searchKB] = KBApi.useSearchKBMutation();
    const canAdd = userProfile?.Features.Add_Asset;
    const { data: ticketAssets } = TicketApi.useGetLinkedAssetsQuery(ticket?.ID, { skip: !ticket?.ID });
    const { data: allAssets } = AssetApi.useGetAssetsQuery({ companyId: ticket.Company_Id, locationId: ticket.Company_Address_Id, contactId: 0 }, { skip: !ticket.Company_Id })


    const itemClicked = (event: any) => {
        //Add asset popup for URl ./Asset.aspx?Origin=AssetPopup&Contact_Id=6129
        navigate(`add-asset`);
    }

    const buttonLabel = `${ticketAssets?.length || 0} / ${allAssets?.length || 0}`;

    //Check if the feature is enabled
    if (!userProfile?.Features.KnowledgeBase || !userProfile?.Features.View_KB) return null;

    return (
        canAdd
            ? <SplitButton disabled={ticket.Is_Loading} onItemClick={itemClicked} items={[{ icon: 'hyperlink-open', text: 'Add Asset' }]} onButtonClick={() => navigate('assets')} title={'Assets: linked / results '} svgIcon={svg.toggleFullScreenModeIcon} text={buttonLabel} />
            : <Button disabled={ticket.Is_Loading} onClick={() => navigate('assets')} title={'Assets: linked / results '} svgIcon={svg.toggleFullScreenModeIcon}>{buttonLabel}</Button>

    );
};

export default AssetButton;